import { Component, OnInit } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { CrudForm } from "src/app/components/shared/cruds/crud.form";
import { FuncionamientosDTO } from "src/app/models/funcionaminetos.dto";

@Component({
    selector: "app-form-drawer-empresas",
  templateUrl: "./drawer-form.component.html",
})
export class FuncionamientoDrawerForm
  extends CrudForm<FuncionamientosDTO>
  implements OnInit
{
  drawerRef: any;
  data?: {
    mode: "create" | "update";
    value: FuncionamientosDTO;
  };
  constructor(public fb: FormBuilder) {
    super(fb);
  }
  public ngOnInit(): void {
    this.buildForm();
    if (this.data) {
      this.defaults = this.data.value;
      if (this.data.mode === "update") {
        this.setUpdate(this.data.value);
      } else {
        this.setCreate();
      }
    }
  }

  // TODO add validators
  public fromInit(row: FuncionamientosDTO) {
    this.form.controls["IdFuncionamiento"].setValue(row?.IdFuncionamiento);
    this.form.controls["Descripcion"].patchValue(row?.Descripcion);
  }

  protected buildForm() {
    this.form = this.fb.group({
      IdFuncionamiento: [""],
      Descripcion: [""],
    });
  }
  public saveOver() {
    this.drawerRef.close({
      valid: this.form.invalid,
      data: {
        mode: this.mode,
        value: this.form.value,
      },
    });
  }
}
